'use client';

import useProduct from '@/contexts/ProductProvider';
import { addFilterParams } from '@/services/ecommerce/utils/helper';
import { Product } from '@/services/ecommerce/types/productTypes';
import { every, find, get, isEmpty } from 'lodash';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { useEffect, useRef } from 'react';

const WrapperProductData = ({ data }: any) => {
	const params = useSearchParams();
	const router = useRouter();
	const pathname = usePathname();
	const pv_id = Number(params.get('pv_id'));
	const prevSelectedAttributesRef = useRef({});

	const {
		setSelectedVariant,
		setLoading,
		setProductImages,
		selectedAttributes,
		setSelectedAttributes,
		product,
		setProduct,
		setShowGenericModel
	} = useProduct();

	useEffect(() => {
		setProductImages([]);
		if (product && product.pv && product.pv.length > 0) {
			const baseVariant = pv_id
				? (product.pv.find((item: any) => item.pv_id === pv_id) as Product['pv'][0])
				: product.pv[0];
			isEmpty(baseVariant?.attachedFiles_pv_images)
				? setProductImages(product?.attachedFiles_p_images)
				: setProductImages(baseVariant?.attachedFiles_pv_images);
			setSelectedVariant(baseVariant);
			setSelectedAttributes(baseVariant?.pv_attribute);
			setLoading(false);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [product]);
	const handleClick = () => {
		setShowGenericModel(true);
	};

	useEffect(() => {
		const genericModelMobile = document.getElementById('generic_modal_mobile');
		const genericModelDesktop = document.getElementById('generic_modal_desktop');
		if (genericModelMobile) {
			genericModelMobile.addEventListener('click', handleClick);
		}
		if (genericModelDesktop) {
			genericModelDesktop.addEventListener('click', handleClick);
		}

		return () => {
			if (genericModelMobile) {
				genericModelMobile.removeEventListener('click', handleClick);
				setShowGenericModel(false);
			}
			if (genericModelDesktop) {
				genericModelDesktop.removeEventListener('click', handleClick);
				setShowGenericModel(false);
			}
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	const findMatchingVariant = () => {
		return find(product?.pv, (variant) => {
			return every(selectedAttributes, (value, key) => {
				return get(variant, `pv_attribute[${key}]`) === value;
			});
		});
	};
	// const onSelectVariant = () => {
	// 	const result = findMatchingVariant();
	// 	if (!result) return;
	// 	const sku = result?.pv_id;
	// 	const updatedParams = addFilterParams(params, { pv_id: sku });
	// 	setSelectedVariant(result);
	// 	const attributes = get(product, 'pv[0].pv_attribute', {});
	// 	const isMultiVariant = Object.keys(attributes).length > 0;
	// 	console.log('isMultiVariant', isMultiVariant);
	// 	if (isMultiVariant) {
	// 		router.push(`${pathname}?${updatedParams}`);
	// 		return;
	// 	}
	// };
	const onSelectVariant = () => {
		const result = findMatchingVariant();
		if (!result) return;
		const sku = result?.pv_id;
		const updatedParams = addFilterParams(params, { pv_id: sku });
		// setSelectedVariant(result);

		if (JSON.stringify(prevSelectedAttributesRef.current) !== JSON.stringify(selectedAttributes)) {
			router.push(`${pathname}?${updatedParams}`);
		}
	};

	useEffect(() => {
		onSelectVariant();
		prevSelectedAttributesRef.current = selectedAttributes;
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedAttributes, pathname, params]);

	useEffect(() => {
		setProduct({
			...data,
			translation: {
				...data.translation,
				en: {
					p_name: data.p_name
				}
			}
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [data]);

	return <></>;
};

export default WrapperProductData;
